import type { FlatInvitation } from '../../../stores/invitationStore.js'
import styles from './common.module.css'

interface FooterBlockProps {
  invitation: FlatInvitation
}

export function FooterBlock({ invitation }: FooterBlockProps) {
  const groomName = invitation.groom?.name || '신랑'
  const brideName = invitation.bride?.name || '신부'

  return (
    <div className={styles.footer}>
      {groomName} & {brideName}
    </div>
  )
}
